"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoresInnerProductsInnerVariantsInnerRgbToJSON = exports.StoresInnerProductsInnerVariantsInnerRgbFromJSONTyped = exports.StoresInnerProductsInnerVariantsInnerRgbFromJSON = exports.instanceOfStoresInnerProductsInnerVariantsInnerRgb = exports.StoresInnerProductsInnerVariantsInnerRgbViewsEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.StoresInnerProductsInnerVariantsInnerRgbViewsEnum = {
    Front: 'front',
    Back: 'back'
};
/**
 * Check if a given object implements the StoresInnerProductsInnerVariantsInnerRgb interface.
 */
function instanceOfStoresInnerProductsInnerVariantsInnerRgb(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoresInnerProductsInnerVariantsInnerRgb = instanceOfStoresInnerProductsInnerVariantsInnerRgb;
function StoresInnerProductsInnerVariantsInnerRgbFromJSON(json) {
    return StoresInnerProductsInnerVariantsInnerRgbFromJSONTyped(json, false);
}
exports.StoresInnerProductsInnerVariantsInnerRgbFromJSON = StoresInnerProductsInnerVariantsInnerRgbFromJSON;
function StoresInnerProductsInnerVariantsInnerRgbFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'r': !(0, runtime_1.exists)(json, 'r') ? undefined : json['r'],
        'g': !(0, runtime_1.exists)(json, 'g') ? undefined : json['g'],
        'b': !(0, runtime_1.exists)(json, 'b') ? undefined : json['b'],
        'views': !(0, runtime_1.exists)(json, 'views') ? undefined : json['views'],
    };
}
exports.StoresInnerProductsInnerVariantsInnerRgbFromJSONTyped = StoresInnerProductsInnerVariantsInnerRgbFromJSONTyped;
function StoresInnerProductsInnerVariantsInnerRgbToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'r': value.r,
        'g': value.g,
        'b': value.b,
        'views': value.views,
    };
}
exports.StoresInnerProductsInnerVariantsInnerRgbToJSON = StoresInnerProductsInnerVariantsInnerRgbToJSON;
